<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.provider'> {{$t('txt.furnizor')}}: {{(parseInt(this.provider.type) === 1) ? (this.provider.first_name + ' ' + this.provider.last_name) : ((parseInt(this.provider.type) === 2) ? this.provider.company_name : '')}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update provider'])">
                <router-link :to="`/providers/${provider.id}/edit`">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper" v-if="!input_field.personType || parseInt(input_field.personType) === parseInt(provider.type) ">
                                    <div class="contact-design">
                                      <i :class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                      <i v-bind:class="input_field.icon"></i>
                                      <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-md-12" v-if="this.provider.user_type">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaTipFurnizor')}} </h4>
                    </div>
                    <ul  class="subtype-view-list">
                        <li class="subtype-view-list" v-for="types in this.provider.user_type" :key="types.id">
                            <i class="fas fa-user-tag"></i>
                            <span>{{types.types.type}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="location-header">
                        <h4 id="scroller"> {{$t('txt.locatii')}} </h4>
                    </div>
                    <div class="location-wrapper animated-section" v-if="this.provider">
                        <div class="location-wrapper-inner" id="location-list-container">
                            <sequential-entrance fromTop delay="70">
                                <div class="location-box" v-for="location in this.provider.locations" :key="location.id">
                                    <ul class="location-inner-list">
                                        <li>
                                            <h4> {{$t('placeholder.denumireLocatie')}} </h4>
                                            <p> {{location.name ? location.name : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.adresa')}} </h4>
                                            <p> {{ fullAddress(location) }} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.linkGoogleMaps')}} </h4>
                                            <p> {{location.link_map ? location.link_map: '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.persoanaContact')}} </h4>
                                            <p> {{location.contact_pers ? location.contact_pers : '-' }} </p>
                                        </li>
                                    </ul>
                                </div>
                            </sequential-entrance>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4 id="scroller2"> {{$t('txt.persoaneContact')}} </h4>
                    </div>
                    <div class="contact-person-wrapper animated-section2" v-if="this.provider">
                        <div class="contact-wrapper-inner" id="contact-list-container">
                            <sequential-entrance fromTop delay="70">
                                <div class="contact-person-box" v-for="contact in this.provider.contacts"
                                     :key="contact.id">
                                    <ul class="contact-inner-list">
                                        <li>
                                            <h4> {{$t('placeholder.nume')}} </h4>
                                            <p> {{contact.name ? contact.name : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.functie')}} </h4>
                                            <p> {{contact.function ? contact.function : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.email')}} </h4>
                                            <p> {{contact.email ? contact.email : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.telefon')}}: </h4>
                                            <p> {{contact.phone ? contact.phone : '-'}} </p>
                                        </li>
                                        <li>
                                            <h4> {{$t('placeholder.notite')}}: </h4>
                                            <p> {{contact.notes ? contact.notes : '-'}} </p>
                                        </li>
                                    </ul>
                                </div>
                            </sequential-entrance>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <div class="documents-list" v-if="this.provider">
                            <div class="document-box" v-for="file in this.provider.files" :key="file.id">
                                <div class="document-content">
                                    <i class="far fa-file-alt"></i>
                                    <section v-if="mimes.includes(file.mime)">
                                        <a v-bind:href="file.link" target="_blank"> {{ file.file_name }} </a>
                                    </section>
                                    <section v-else>
                                        <a :href="file.link" download> {{ file.file_name }} </a>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea v-model="this.provider.notes" name='notes' disabled></textarea>
                        <div class="save-contact-buttons">
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="!this.provider.is_transformed_in_contact">
                    <div class="save-as-contact">
                        <button type="button" @click='saveAsContact()' :disabled="this.$store.state.loading">
                            <i class="fas fa-save"></i>
                            {{$t('txt.salveazaCaSiContact')}}
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>

<script>

import ProvidersService from '../../api-services/providers.service.js'

export default {
  name: 'viewprovider',
  data () {
    return {
      provider: {
        id: null,
        type: null,
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        phone: null,
        county: null,
        city: null,
        address: null,
        cui: null,
        nr_reg: null,
        bank: null,
        site: null,
        delegat: null,
        date_corespondenta: null,
        notes: null,
        has_account: null,
        is_transformed_in_contact: null,
        locations: null,
        contacts: null,
        files: null
      },
      mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']
    }
  },
  methods: {
    getProvider () {
      ProvidersService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.provider = response.data.data
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    saveAsContact () {
      ProvidersService.transformInContact(this.$route.params.id)
        .then((response) => {
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.contactAdaugat'),
            'animation-type': 'css'
          })
          this.provider.contacts.push(response.data.data)
          this.provider.is_transformed_in_contact = true
          window.scrollTo(0, 0)
        })
        .catch((error) => {
          console.log(error)
          this.$notify({
            group: 'error',
            type: 'error',
            title: this.$t('errors.errorTitle'),
            text: error.response.data.error,
            'animation-type': 'css'
          })
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'type',
            labelName: this.$t('txt.tipulDePersoana'),
            inputValue: (this.provider) ? (parseInt(this.provider.type) === 2) ? this.$t('txt.persJuridica') : this.$t('txt.persFizica') : null,
            icon: 'fas fa-user-tag'
          },
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.provider) ? this.provider.first_name : null,
            icon: 'fas fa-signature',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.provider) ? this.provider.last_name : null,
            icon: 'fas fa-signature',
            personType: 1
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: (this.provider) ? this.provider.cnp : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: (this.provider) ? this.provider.ci_series : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: (this.provider) ? this.provider.ci_number : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.provider) ? this.provider.company_name : null,
            icon: 'fas fa-building',
            personType: 2
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.provider) ? this.provider.phone : null,
            icon: 'fas fa-phone'
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.provider) ? this.provider.cui : null,
            icon: 'fas fa-scroll',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.provider) ? this.provider.nr_reg : null,
            icon: 'fas fa-cash-register',
            personType: 2
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.provider) ? this.provider.bank : null,
            icon: 'fas fa-piggy-bank'
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.provider.county) ? this.provider.county.name : null,
            icon: 'fas fa-city',
            validationRules: 'alpha'
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.provider.city) ? this.provider.city.name : null,
            icon: 'fas fa-city',
            validationRules: 'alpha'
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.provider) ? this.provider.address : null,
            icon: 'fas fa-map-marker-alt'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.provider) ? this.provider.email : null,
            icon: 'fas fa-envelope'
          },
          {
            inputName: 'delegat',
            labelName: this.$t('placeholder.delegat'),
            inputValue: (this.provider) ? this.provider.delegat : null,
            icon: 'fas fa-user-tie'
          },
          {
            inputName: 'date_corespondenta',
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            inputValue: (this.provider) ? this.provider.date_corespondenta : null,
            icon: 'fas fa-info'
          },
          {
            inputName: 'site',
            labelName: this.$t('placeholder.siteWeb'),
            inputValue: (this.provider) ? this.provider.site : null,
            icon: 'far fa-window-maximize'
          },
          {
            inputName: 'created_at',
            labelName: this.$t('txt.dataAdaugare'),
            inputValue: (this.provider) ? this.provider.created_at : null,
            icon: 'fas fa-calendar-alt'
          }
        ]
      }
    }
  },
  mounted () {
    this.getProvider()
  }
}
</script>
